/* eslint-disable @angular-eslint/prefer-standalone */
import {
  faXTwitter as fabXTwitter, faLinkedin as fabLinkedin, faInstagram as fabInstagram, faYoutube as fabYoutube,
  faFacebook as fabFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { environment } from 'src/environments/environment';



@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements AfterViewInit {

  public version: string;
  @ViewChild('footer') footer: ElementRef<HTMLInputElement>;

  constructor(library: FaIconLibrary) {
    library.addIcons(fabFacebook, fabXTwitter, fabLinkedin, fabInstagram, fabYoutube);
    this.version = "25.04.2025";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const footerElement = document.querySelector('tds-footer');
      if (footerElement && footerElement.shadowRoot) {
        const copyright = footerElement.shadowRoot.querySelector('.copyright');
        if (copyright) {
          // Usar a variável de ambiente que contém o timestamp do build
          const buildVersion = environment.buildVersion;

          const dataAtual = document.createElement('small');
          dataAtual.className = 'copyright';
          dataAtual.textContent = `Version ${buildVersion}`;
          copyright.insertAdjacentElement('afterend', dataAtual);
        }
      }
    }, 1000);
  }

}
